module.exports = __webpack_public_path__ + "static/media/fastapi_sklearn.f7d742fc.png";